// extracted by mini-css-extract-plugin
export default {"logoutBtn":"styles_logoutBtn__GvVCO","button":"styles_button__kOCEz","confirmBtn":"styles_confirmBtn__-MT3n"};